import React, { useEffect } from "react";
import { useSelector } from 'react-redux'
import { useHistory,useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import './Home.css'
import TopMenu from "./TopMenu";
import MainFrame from "./MainFrame";
import Profile from "./Profile";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import RoadMap from "../Footer/RoadMap";

export function HomeDossier({props}) {
    const auth = useSelector(state => state.auth);
    const history = useHistory()

   
    console.log(history);

    useEffect(() => {
        if (auth == null) {
            history.push('/login')
        }
    }, [])

    
    return (
        <ReactCSSTransitionGroup
                transitionAppear={true}
                transitionAppearTimeout={600}
                transitionEnterTimeout={600}
                transitionLeaveTimeout={200}
                transitionName={history.location.pathname === '/home/dossiers' ? 'SlideIn' : 'SlideOut'}
            >
        <div className="home">

                <div className="home_main">
                    <TopMenu />
                    <MainFrame />
                    <RoadMap/>
                </div>

        </div>
            </ReactCSSTransitionGroup>
    )
}



export function HomeProfile({props}) {
    const history = useHistory()
    return (
        <ReactCSSTransitionGroup
                transitionAppear={true}
                transitionAppearTimeout={600}
                transitionEnterTimeout={600}
                transitionLeaveTimeout={200}
                transitionName={history.location.pathname === '/home/compte' ? 'SlideIn' : 'SlideOut'}
            >
        <div className="home">

                <div className="home_main">
                    <TopMenu />
                    <Profile />
                    <RoadMap/>
                </div>
        </div>
            </ReactCSSTransitionGroup>
    )
}
